import { el } from "../dom.js";
import { formatTimestamp } from "../time.js";
import type { Comment } from "../types.js";

export function commentRow(c: Comment, now: Date = new Date()): HTMLElement {
  const author = c.authorType === "user" ? "You" : c.authorId || c.authorType;
  const timeLabel = formatTimestamp(c.createdAt, now);
  return el("div", { class: "comment" }, [
    el("div", { class: "comment-author" }, [author]),
    c.body ? el("div", { class: "comment-body" }, [c.body]) : "",
    timeLabel ? el("span", { class: "comment-time meta" }, [timeLabel]) : "",
  ]);
}
